import ObjectTableController from "./object_table_controller"

export default class ExchangeMarketAssetsObjectTableController extends ObjectTableController {
  static values = {
    ...ObjectTableController.values,
    listTypeFriendlyName: "asset",
    subjectType: "asset",
    parentSubjectType: "market",
    enableEdit: false,
    isFavouriteEnabled: false,
  }
}
